import Hero from "./landing/Hero";
import WhyFlexFund from "./landing/WhyFlexFund";
import Comparison from "./landing/Comparison";
import AccountSelector from "./landing/AccountSelector";
import AssetStrip from "./landing/AssetStrip";
import StepsPreview from "./landing/StepsPreview";
import Infrastructure from "./landing/Infrastructure";
import ClosingCTA from "./landing/ClosingCTA";
import GridBackdrop from "@/components/visual/GridBackdrop";
import { usePageMeta } from "@/lib/usePageMeta";
import { useLocale } from "@/i18n/useLocale";
import { landingMetaFor } from "@/content/landing";
import { useLandingStructuredData } from "@/lib/seo";

export default function LandingPage(): JSX.Element {
  const meta = landingMetaFor(useLocale());
  usePageMeta({
    title: meta.title,
    description: meta.description,
  });
  useLandingStructuredData();
  return (
    <>
      <GridBackdrop />
      <div className="animate-page-in relative z-[1]">
        <Hero />
        <WhyFlexFund />
        <Comparison />
        <AccountSelector />
        <StepsPreview />
        <Infrastructure />
        <AssetStrip />
        <ClosingCTA />
      </div>
    </>
  );
}
